import {UPDATE_GROWTH_PATH_START} from "../../types";

export const update_growth_path = (payload) => ({
    type: UPDATE_GROWTH_PATH_START,
    payload,
});
